module.exports = __webpack_public_path__ + "static/media/cloud.c970dad4.svg";